import CountryService from './CountryService';

export default class VatService {

  private static _instance: VatService;

  public static GetInstance() {
    if (this._instance == undefined) {
      this._instance = new VatService();
    }

    return this._instance;
  }

  /**
   * Zobrazení textů "incl. VAT"
   * 
   * @param vat Pokud je null, vygeneruje se z aktuální země, pokud je undefined bude bez označení výše DPH
   * @param country Země
   */
  public displayIncludeVat(
    vat: number | undefined | null = null, 
    country: GQL.ICountry | null = null
  ) {
    const { countryCode, VATrate } = CountryService.GetInstance();

    const isAmerica = country 
      ? country.code === 'us' 
      : countryCode === 'us';

    if (vat === null) {
      vat = VATrate;
    }

    return `${vat === 0 ? `excl. ` : `incl. `}${isAmerica ? 'GST' : 'VAT'}${vat && vat > 0 ? ` (${vat} %)` : ``} `;
  }
}


// WEBPACK FOOTER //
// ./src/services/VatService.ts